import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'EOD Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true
    },
    {
        id: 'csa',
        title: 'CSA',
        type: filterHeaderTypes.filterTypes.radioList,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/csas',
        server: true,
        fixed: true
    }
];

export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    },
    {
        value: [],
        definition: filterDefinitions.find(def => def.id === 'csa')
    }
];

export const columns = [
    { id: 'riskType' },
    { id: 'qualifier' },
    { id: 'bucket' },
    { id: 'labelOne' },
    { id: 'labelTwo' },
    { id: 'amount' },
    { id: 'amountCcy' },
    { id: 'amountUsd' },
    { id: 'prodClass' },
    { id: 'tradeId' },
    { id: 'imModel' },
    { id: 'valuationDate' }
];

export const fakeRows = [
    {
        riskType: 'risk',
        qualifier: 'qual',
        bucket: 'bucket',
        labelOne: 'label1',
        labelTwo: 'label2',
        amount: 'amount',
        amountCcy: 'amountccy',
        amountUsd: 'amountUsd',
        prodClass: 'prodClass',
        tradeId: 'tradeId',
        imModel: 'immodel',
        valuationDate: 'val Date'
    }
];
